export default __webpack_public_path__ + "static/media/kivengi.674e2ab6.jpg";